import React from 'react';
import { Form } from 'react-bootstrap';

import styles from './Radio.module.scss';

interface Props {
  name?: string;
  label?: string;
  checked?: boolean;
  onChange?: React.ChangeEventHandler;
}

const Radio = ({ label, name, checked, onChange }: Props) => (
  <Form.Check className={styles.radio}>
    <Form.Check.Input
      type="radio"
      id={name}
      name={name}
      className={styles.radio__input}
      onChange={onChange}
      checked={checked}
    />
    <Form.Check.Label htmlFor={name}>{label}</Form.Check.Label>
  </Form.Check>
);

Radio.defaultProps = {
  name: '',
  label: '',
  checked: false,
  onChange: () => {},
};

export default Radio;
